import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SwalService } from '@shared/utils/swal.service';
import { EmpresasService } from '../../../../services/empresas.service';
import { IPromocionAll } from '../../../../interfaces/IPromociones';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-abc-empresas-promociones-form',
  templateUrl: './abc-empresas-promociones-form.component.html'
})
export class AbcEmpresasPromocionesFormComponent implements OnInit {
  form: FormGroup;
  loading = false;
  modelRecived: any = null;
  listPromociones: { value: string, label: string }[] = [];
  empresa: string;
  nombreSucursal: string;

  constructor(
    private fb: FormBuilder,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private _swalService: SwalService,
    private empresasService: EmpresasService
  ) {
    if (this.config.data) {
      this.empresa = this.config.data.empresa;
      this.nombreSucursal = this.config.data.nombreSucursal;
      this.modelRecived = this.config.data.promocion;
    }
    this.initForm();
    if (this.modelRecived) {
      this.setFormData();
    }
  }

  ngOnInit(): void {
    this.getPromociones();
    this.getPromocionaut6();
  }

  initForm(): void {
    this.form = this.fb.group({
      empresa: [{ value: this.config.data?.claveEmpresa || '', disabled: true }],
      sucursal: [{ value: this.config.data?.claveSucursal || '', disabled: true }],
      promocion: ['', [Validators.required]]
    });
  }

  setFormData(): void {
    if (this.modelRecived) {
      this.form.patchValue({
        empresa: this.config.data.claveEmpresa,
        sucursal: this.config.data.claveSucursal,
        promocion: this.modelRecived.promocion
      });
    }
  }

  getPromociones(): void {
    this.loading = true;
    const payload = {
      limit: "10"
    };

    this.empresasService.GetAllPromociones(payload).subscribe({
      next: (response) => {
        if (response.success) {
          this.listPromociones = response.data.map(item => ({
            value: item.sPromocion,
            label: `${item.sPromocion} - ${item.descripcion}`
          }));
        } else {
          this._swalService.error('Error al obtener las promociones');
        }
        this.loading = false;
      },
      error: (error) => { 
        console.error('Error al obtener promociones:', error);
        this._swalService.error('Error al obtener las promociones');
        this.loading = false;
      }
    });
  }

  getPromocionaut6(): void {
    const payload = {
      tope: "",
      sEmpresa: this.config.data.claveEmpresa,
      sSucursal: this.config.data.claveSucursal,
      sPromocion: ""
    };

    this.empresasService.GetPromocionaut6(payload).subscribe({
      next: (response) => {
        if (response.success) {
          // Aquí puedes usar los datos de response.data si los necesitas
          // Por ejemplo, para mostrar información adicional
        } else {
          this._swalService.error('Error al obtener información de la promoción');
        }
      },
      error: (error) => {
        console.error('Error al obtener información de la promoción:', error);
        this._swalService.error('Error al obtener información de la promoción');
      }
    });
  }

  formValue(field: string) {
    return this.form.get(field);
  }

  create(formData: any): void {
    if (this.form.valid) {
      Swal.fire({
        title: '¿Está seguro?',
        text: '¿Desea crear esta promoción?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, crear',
        cancelButtonText: 'No',
        heightAuto: false,
        customClass: {
          container: 'swal-index'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          const payload = {
            que: 1,
            tope: "",
            sEmpresa: this.config.data.claveEmpresa,
            sSucursal: this.config.data.claveSucursal,
            sPromocion: formData.promocion
          };

          this.empresasService.CreatePromocion(payload).subscribe({
            next: (response) => {
              if (response.success && response.data.error === 0) {
                this._swalService.success('Promoción creada correctamente');
                this.ref.close(true);
              } else {
                this._swalService.error('Error al crear la promoción');
              }
              this.loading = false;
            },
            error: (error) => {
              console.error('Error al crear promoción:', error);
              this._swalService.error('Error al crear la promoción');
              this.loading = false;
            }
          });
        }
      });
    }
  }
} 